export enum CompanyPolicyStatus {
  Draft = 0,
  Submitted = 1,
  Inactive = 2,
  Deleted = 3,
}

export const PolicyStatusLabels: Record<CompanyPolicyStatus, string> = {
  [CompanyPolicyStatus.Draft]: "Draft",
  [CompanyPolicyStatus.Submitted]: "Submitted",
  [CompanyPolicyStatus.Inactive]: "Inactive",
  [CompanyPolicyStatus.Deleted]: "Deleted",
};

export const PolicyStatusColors: Record<CompanyPolicyStatus, string> = {
  [CompanyPolicyStatus.Draft]: "#fbc02d",
  [CompanyPolicyStatus.Submitted]: "#1976d2",
  [CompanyPolicyStatus.Inactive]: "#777",
  [CompanyPolicyStatus.Deleted]: "#d32f2f",
};
